import React, {useEffect, useState} from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Button from 'components/ui/Button';
import {enqueueSnackbar} from 'notistack';
import {useUpdateBookingSlotNoteMutation} from 'services/orders';

interface BookingNoteEditorProps {
    bookingSlotId: string;
    initialNote: string;
}

const BookingNoteEditor: React.FC<BookingNoteEditorProps> = ({ bookingSlotId, initialNote }) => {
    const [note, setNote] = useState(initialNote);
    const [updateBookingSlotNote, { isLoading }] = useUpdateBookingSlotNoteMutation();

    useEffect(() => {
        setNote(initialNote);
    }, [initialNote]);

    const handleNoteChange = (content: string) => {
        setNote(content);
    };

    const handleSaveNote = async () => {
        try {
            await updateBookingSlotNote({ id: bookingSlotId, note }).unwrap();
            enqueueSnackbar('Note updated successfully', { variant: 'success', autoHideDuration: 1000 });
        } catch (error) {
            console.error('Failed to update note:', error);
            enqueueSnackbar('Failed to update note. Please try again.', { variant: 'error', autoHideDuration: 1000 });
        }
    };

    return (
        <div>
            <ReactQuill
                theme="snow"
                value={note}
                onChange={handleNoteChange}
                modules={{
                    toolbar: [
                        [{ 'header': '1'}, {'header': '2'}, { 'font': [] }],
                        [{size: []}],
                        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
                        [{'list': 'ordered'}, {'list': 'bullet'},
                            {'indent': '-1'}, {'indent': '+1'}],
                    ],
                }}
            />
            <div style={{ marginTop: '10px', display: 'flex', justifyContent: 'flex-end' }}>
                <Button onClick={handleSaveNote} disabled={isLoading} cc-color="purple">
                    {isLoading ? 'Saving...' : 'Save Note'}
                </Button>
            </div>
        </div>
    );
};

export default BookingNoteEditor;
